export default __webpack_public_path__ + "static/media/sass.a2591e27.png";